module.exports = __webpack_public_path__ + "img/team-member-3.067cbb4b.png";